/// <amd-module name="Search/ExtensionStatus/Components/Pivot" />
import * as React from "react";
import { EntityTypeUrlParam } from "Search/ExtensionStatus/Constants";
import { ExtensionStatus } from "Search/ExtensionStatus/Components/ExtensionStatus";
import { ITabContext } from "Search/Shared/Base/Types";
import { VssComponent } from "VSS/Platform/Layout";
import { RelationFromExactCount } from "Search/LegacyWebApi/Contracts/Search.SharedLegacy";

export class ExtensionStatusPivot extends VssComponent<ITabContext> {
    public render(): JSX.Element {
        return <ExtensionStatus pageContext={this.context.pageContext} />;
    }

    public componentDidMount(): void {
        // reset tab count
        this.props.resultsCount[EntityTypeUrlParam].value = { count: 0, relationFromExactCount: RelationFromExactCount.Equals};
        // reset tab commands
        this.props.pivotCommands.value = { farItems: [], items: [] };
    }
}

VssComponent.register("extensionStatusPivot", ExtensionStatusPivot);
